export default defineNuxtRouteMiddleware((to) => {
	if (process.server) return

	const nuxtApp = useNuxtApp()
	const isPanel = to.path.includes('/panel')

	if (isPanel) {
		const adminStore = useAdminAuthStore()
		const isLoggedAdmin = useCookie('is_logged_admin')
		if (isLoggedAdmin.value && !adminStore.state.user) {
			adminStore.fetchUser().catch(() => {
				nuxtApp.runWithContext(() => adminStore.logout())
			})
		} else if (!isLoggedAdmin.value && adminStore.state.user) {
			nuxtApp.runWithContext(() => adminStore.logout())
		}
		return
	}

	const isLogged = useCookie('is_logged')
	const userStore = useUserStore()
	if (isLogged.value && !userStore.state.user) {
		userStore.fetchUser().catch(() => {
			nuxtApp.runWithContext(() => userStore.logout())
		})
	} else if (!isLogged.value && userStore.state.user) {
		nuxtApp.runWithContext(() => userStore.logout())
	}
})
